export enum VerticalMenuTabsEnum {
    ICP_AUTOMATIONS = 'Ideal Customer Profile Automations',
    EXPORT_ERRORS = 'Export Errors',
}
